import * as A from '../admin'
import {AbstractBlockConfig} from './meta'

export const Admin: A.Admin<AbstractBlockConfig> = () => {
  const tabs = A.useBackgroundConfigTabs({name: 'background'})
  const propOptions = A.usePropOptions({
    spec: 'sub-prop-defs',
    types: ['html', 'keyword', 'markdown', 'string', 'text'],
  })
  const containerOptions = A.useOptions<AbstractBlockConfig['container']>(
    A.containerOptions,
  )
  const justificationOptions = A.useOptions<
    AbstractBlockConfig['justification']
  >(A.justificationOptions)

  return (
    <A.Tabs>
      <A.Tab title="Content">
        <A.Input label="Heading" name="heading" />
        <A.Select
          label="Property"
          name="prop"
          noneOption={true}
          options={propOptions}
        />
      </A.Tab>
      <A.Tab title="Presentation">
        <A.SubTabs>
          <A.SubTab title="Background">
            {Object.entries(tabs.background).map(([k, props]) => (
              <A.SubGroup key={k} {...props} />
            ))}
          </A.SubTab>
          <A.SubTab title="Foreground">
            {Object.entries(tabs.foreground).map(
              ([k, {children, ...props}]) => (
                <A.SubGroup key={k} {...props}>
                  {k === 'layout' && (
                    <A.Radio
                      label="Text container"
                      name="container"
                      options={containerOptions}
                    />
                  )}
                  {children}
                  {k === 'layout' && (
                    <A.Radio
                      label="Text justification"
                      name="justification"
                      options={justificationOptions}
                    />
                  )}
                </A.SubGroup>
              ),
            )}
          </A.SubTab>
        </A.SubTabs>
      </A.Tab>
    </A.Tabs>
  )
}
